module.exports = __webpack_public_path__ + "static/media/live13_06_2019.f90800f8.jpg";